export const suppliersDistributorsVATFilterOn = [
  "65bf6f6284ae4ba880ac4722375a91ea_spp", // TD Entertainment C.V.
  "5996d72153ad41308a97625e7fa03ff5_dst", // A. Ostermann GMBH
  "fsd69f4k5d9a143369e63tuio0005cp8_spp", // Motorsport tickets
  "9fad6b504890402baab2d6fb7d1878ca_dst", // Book Events
  "2b152897e6574139a3c35284044c5057_dst", // Platinium Group SAM
  "c1771cb0e8fb4383b7107a88116d8542_spp", // Grand Prix Tickets Ges.m.b.H.
  "cde198b77cd74155a6bf96dbbb518135_spp", // GPtickets s.r.o.
  "ef30a9c6b3c447829615c92cda06d148_spp", // Across Spain
  "c2f753f63f834cfa83f668dca59115e9_dst", // Passion Events
  "b599521988d5442b96ff923be68c2a17_dst", // All Sport srl (distributor)
  "3f689465bf5f400ba416551230bd74c5_spp", // Xperience for you GmbH
  "c2bb4ddab4934fc983c022456ad2516c_dst", // Xperience for you GmbH
  "0e6692a6fc7e4d6f90060329dd409dba_spp", // All Sport SRL (supplier)
];

export const suppliersLeadNameForPickupRequired = [
  "a69e3a3537c940b491286900ff0df82a_spp", // F1Experiences - Quint Events
  "ac7e69261db3460fb8e239e213ec460b_spp", // F1Experiences - Quint Events (MP)
];

export const isLeadNameForPickupSupplier = (supplierId?: string) =>
  !!supplierId && suppliersLeadNameForPickupRequired.includes(supplierId);

export const hasLeadNameForPickupSupplierInCart = (items: Array<{ ticket?: { supplier_id?: string } }> = []) =>
  items.some((item) => isLeadNameForPickupSupplier(item?.ticket?.supplier_id));
